import { cached } from '@porotutu/react'
import { PendingPage, statusPagesFor } from '@porotutu/react/components/StatusPage/StatusPage'
import type { QueryClient } from '@tanstack/react-query'
import { createRoute, createRouter, redirect } from '@tanstack/react-router'
import { auditRoutes } from '../features/audit/route'
import { authRoutes } from '../features/auth/route'
import { organizationRoutes } from '../features/organizations/route'
import { profileRoutes } from '../features/profile/route'
import { rolesRoutes } from '../features/roles/route'
import { userRoutes } from '../features/users/route'
import { profileQuery } from '../session/profile'
import { HOME, rootRoute, signedInRoute } from './root'

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: async ({ context }) => {
    const signedIn = (await context.queryClient.query(cached(profileQuery))) !== null

    throw redirect({ to: signedIn ? '/organizations' : '/sign-in', replace: true })
  },
})

const routeTree = rootRoute.addChildren([
  indexRoute,
  ...authRoutes,
  signedInRoute.addChildren([
    ...organizationRoutes,
    ...userRoutes,
    ...auditRoutes,
    ...rolesRoutes,
    ...profileRoutes,
  ]),
])

const { ErrorPage, NotFoundPage } = statusPagesFor(HOME)

export const buildRouter = (queryClient: QueryClient) =>
  createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ErrorPage,
    defaultNotFoundComponent: NotFoundPage,
    defaultPendingComponent: PendingPage,
  })

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof buildRouter>
  }
}
